import { uid } from '../../../../lib/uid';

/*
  Wordings a competency framework plausibly uses, which is what this form actually configures.
  Plausible vocabulary is the right call here: unlike a person's name, a competency's wording
  never leaves `rsys_` and never lands in the identity store, and an unreadable one would make
  the generated form worse at the one job it has — showing what the fields are for.
*/
const COMPETENCIES = [
  'Policy Development',
  'Budget Preparation',
  'Quality Assurance',
  'Risk Assessment',
  'Public Speaking',
  'Vendor Management',
  'Incident Response',
];

const GROUPS = ['Core', 'Leadership', 'Technical'];

/**
 * A sample competency, so the create form fills in one click.
 *
 * **The name is suffixed because it is unique among active rows.** Autogenerate is most useful
 * clicked repeatedly, and the create is idempotent on the name — so without a suffix the second
 * click would quietly return the first row rather than adding one, which reads as the button
 * having stopped working.
 *
 * Applied on an edit as well as a create, per the Autogenerate rule: these are development
 * records, and the form a reader most often needs filled fast is the one over a half-empty row.
 */
export function sampleCompetency(): {
  name: string;
  category: string;
  description: string;
} {
  const tag = uid().slice(0, 4).toUpperCase();

  return {
    name: `${COMPETENCIES[Math.floor(Math.random() * COMPETENCIES.length)]} ${tag}`,
    category: GROUPS[Math.floor(Math.random() * GROUPS.length)],
    description: `Sample competency ${tag}. Delete it once the real framework is in.`,
  };
}
